import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

import { environment } from '../../environments/environment';
import { User } from '../models';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    currentUser: Observable<User>;

    constructor(
        private http: HttpClient,
        @Inject(PLATFORM_ID) private readonly platformId: Object
        ) {
        if (isPlatformBrowser(this.platformId)) {
            this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
            this.currentUser = this.currentUserSubject.asObservable();
        }

    }

    public get currentUserValue(): any {
        if (isPlatformBrowser(this.platformId)) {
            return this.currentUserSubject.value;
        }
    }

    login(email: string, password: string) {
        return this.http.post<any>(`${environment.apiUrl}/auth/login`, { email, password })
            .pipe(map(user => {
                const data = user.data;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                if (isPlatformBrowser(this.platformId)) {
                    localStorage.setItem('currentUser', JSON.stringify(data));
                    
                }
                
                this.currentUserSubject.next(data);             
                return data;
            }));
    }
 
    register(value:any) {
        return this.http.post<any>(`${environment.apiUrl}/auth/register`, value)
            .pipe(map(user => {
                const data = user.data;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                if (isPlatformBrowser(this.platformId)) {
                    localStorage.setItem('currentUser', JSON.stringify(data));
                    
                }
                
                this.currentUserSubject.next(data);             
                return data;
            }));
    }

    recover(value:any) {
        return this.http.post<any>(`${environment.apiUrl}/auth/forgot-password`, value)
    }


    forgotPassword(data:any){
        return this.http.post<any>(`${environment.apiUrl}/auth/change-without-password/`, data)
    }

    logout() {
        // remove user from local storage to log user out
        if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem('currentUser');
        }
        this.currentUserSubject.next(null);
    }
}